// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics, isSupported } from "firebase/analytics";

// Your web app's Firebase config
const firebaseConfig = {
    apiKey: "AIzaSyCxutnH4XZuDDAsXfE3-oA0NpAk-gNdZ_Q",
    authDomain: "luxestrive-ai-8f246.firebaseapp.com",
    projectId: "luxestrive-ai-8f246",
    storageBucket: "luxestrive-ai-8f246.firebasestorage.app",
    messagingSenderId: "28196767687",
    appId: "1:28196767687:web:909ef969502e7e7a007be2",
    measurementId: "G-SWB1BQP7PE"
  };

// Initialize Firebase app
const app = initializeApp(firebaseConfig);

// Initialize Firebase Auth
export const auth = getAuth(app);

// Initialize Firebase Analytics (only if supported by environment)
let analytics = null;
isSupported().then((yes) => {
  if (yes) {
    analytics = getAnalytics(app);
  }
});

export { analytics };